import { render, staticRenderFns } from "./NavPage.vue?vue&type=template&id=4a7d7309&scoped=true"
import script from "./NavPage.vue?vue&type=script&lang=js"
export * from "./NavPage.vue?vue&type=script&lang=js"
import style0 from "./NavPage.vue?vue&type=style&index=0&id=4a7d7309&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.97.1__lodash@4.17.21__o37vjc56bbn3qeic3ehqykr2mu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d7309",
  null
  
)

export default component.exports